export default "__VITE_ASSET__DuZHe3XH__"